import React from 'react'
import { Outlet } from 'react-router-dom';

function MainItems() {
  return (
    <div className='w-full h-full'>
    <Outlet/>
</div>
  )
}

export default MainItems